import { render, staticRenderFns } from "./feeRemindList.vue?vue&type=template&id=3a6a4202&scoped=true"
import script from "./feeRemindList.vue?vue&type=script&lang=js"
export * from "./feeRemindList.vue?vue&type=script&lang=js"
import style0 from "./feeRemindList.vue?vue&type=style&index=0&id=3a6a4202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6a4202",
  null
  
)

export default component.exports